import { useTranslation } from 'react-i18next';
import { DocumentTitle } from 'components/DocumentTitle';

import { Loader } from 'components/Loader';
import { useTrack } from 'utils/hooks/useMixPanel';
import { ContentContainer } from 'components/ContentContainer';
import { SUPPORT_MIXPANEL_EVENTS } from './mixpanel';
import { SupportHero } from './components/SupportHero';
import { SupportCategoriesList } from './components/CategoriesList';

type SupportUiProps = {
  loading?: boolean;
};

export const SupportUi = ({ loading }: SupportUiProps) => {
  const { t } = useTranslation();
  useTrack(SUPPORT_MIXPANEL_EVENTS.viewed.support);

  return (
    <>
      <DocumentTitle>{t('support.pageTitle')}</DocumentTitle>

      <ContentContainer className="bg-cream-50 min-h-full flex flex-col" variant="full">
        {loading && (
          <Loader
            data-testid="billing-loader"
            className="flex grow items-center justify-center p-24 text-primary-500"
          />
        )}

        <SupportHero />
        <SupportCategoriesList />
      </ContentContainer>
    </>
  );
};
